import { frontendURL } from 'dashboard/helper/URLHelper';
import TicketsView from './TicketsView.vue';

const TICKETS_PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tickets'),
    name: 'tickets_view',
    meta: {
      permissions: TICKETS_PERMISSIONS,
    },
    component: TicketsView,
  },
];
